import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  class: "spinner",
  viewBox: "0 0 50 50"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "25",
  cy: "25",
  r: "20",
  fill: "none",
  stroke: "#888",
  "stroke-dasharray": "100",
  "stroke-linecap": "round",
  "stroke-width": "3"
}, [
  /*#__PURE__*/_createElementVNode("animateTransform", {
    attributeName: "transform",
    dur: "1s",
    from: "0 25 25",
    repeatCount: "indefinite",
    to: "360 25 25",
    type: "rotate"
  })
], -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }